import { DashboardBlockItemCommonProps } from "@/dashboard/blocks/DashboardBlockItem"
import { useFragment } from "react-relay"
import { graphql } from "relay-runtime"
import DashboardBlockItemTemplate from "../DashboardBlockItemTemplate"
import ContinueYourProductsDashboardBlockContent from "./ContinueYourProductsDashboardBlockContent"
import { ContinueYourProductsDashboardBlockFragment$key } from "./__generated__/ContinueYourProductsDashboardBlockFragment.graphql"

interface Props extends DashboardBlockItemCommonProps {
  dashboardBlockKey: ContinueYourProductsDashboardBlockFragment$key
}

export default function ContinueYourProductsDashboardBlock({
  dashboardBlockKey,
  index,
  dashboardColumnHoveredShowableClass,
}: Props) {
  const block = useFragment<ContinueYourProductsDashboardBlockFragment$key>(
    graphql`
      fragment ContinueYourProductsDashboardBlockFragment on ContinueYourProductsDashboardBlock {
        id
        position
        products {
          totalCount
        }
        ...DashboardBlockItemTemplateFragment
        ...DashboardBlockAdminDropdownFragment
      }
    `,
    dashboardBlockKey
  )

  return (
    <DashboardBlockItemTemplate
      dashboardBlockKey={block}
      index={index}
      dashboardColumnHoveredShowableClass={dashboardColumnHoveredShowableClass}
    >
      <ContinueYourProductsDashboardBlockContent block={block} />
    </DashboardBlockItemTemplate>
  )
}
